export default __webpack_public_path__ + "static/chatbot-20b6229d33f9a6cebb7fcff9d6a231bd.png";